import React, { useEffect } from 'react';
import LandingNavbar from './components/LandingNavbar';
import LandingHero from './components/LandingHero';
import LandingPillars from './components/LandingPillars';
import LandingHowItWorks from './components/LandingHowItWorks';
import LandingCTA from './components/LandingCTA';
import LandingFooter from './components/LandingFooter';
import LandingFAQ from './components/LandingFAQ';

export default function LandingPage() {
  useEffect(() => {
    const existing = document.getElementById('landing-fonts');
    if (!existing) {
      const link = document.createElement('link');
      link.id = 'landing-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@500;600&display=swap';
      document.head?.appendChild(link);
    }
  }, []);

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: '#f8fafc', minHeight: '100vh' }}>
      <LandingNavbar />
      <LandingHero />
      <LandingPillars />
      <LandingHowItWorks />
      <LandingCTA />
      <LandingFAQ />
      <LandingFooter />
    </div>
  );
}
